import { FC, ReactNode } from 'react'

import { useQuery } from '@tanstack/react-query'
import { getRouteApi } from '@tanstack/react-router'
import { siteAuditDocumentsReportQueryOptions } from '~bank-reports/service/siteAuditDocumentsReportQueryOptions'
import {
  SiteAuditDocumentsReportFilterParams,
  siteAuditDocumentsReportFilterParamsSchema
} from '~bank-reports/types/SiteAuditDocumentsReport'

import { SiteAuditDocumentsReportContext } from './SiteAuditDocumentsReportContext'

type SiteAuditDocumentsReportProviderProps = {
  children: ReactNode
}

export const SiteAuditDocumentsReportContextProvider: FC<SiteAuditDocumentsReportProviderProps> = ({
  children
}: SiteAuditDocumentsReportProviderProps) => {
  const routeApi = getRouteApi('/_app/reports/compliance-review')

  const search = routeApi.useSearch()
  const navigate = routeApi.useNavigate()

  const siteAuditDocumentsReportQuery = useQuery(siteAuditDocumentsReportQueryOptions(search))

  const value = {
    data: siteAuditDocumentsReportQuery.data,
    isPending: siteAuditDocumentsReportQuery.isLoading || siteAuditDocumentsReportQuery.isRefetching,
    successFullyLoaded: !!siteAuditDocumentsReportQuery.data,
    state: { ...siteAuditDocumentsReportQuery.data?.form, ...search },
    navigate: (searchParams: Partial<SiteAuditDocumentsReportFilterParams>) =>
      navigate({ to: '.', search: (prev) => ({ ...prev, ...searchParams }), resetScroll: false, replace: true }),
    clear: () =>
      navigate({
        to: '.',
        search: siteAuditDocumentsReportFilterParamsSchema.parse({}),
        resetScroll: false,
        replace: true
      })
  }

  return <SiteAuditDocumentsReportContext.Provider value={value}>{children}</SiteAuditDocumentsReportContext.Provider>
}
